'use strict'

// Website wide scripts
// @Author Dummy Team

$( () => {

  $(window).ready( () => {
    initTrigger();
  })
})

function initTrigger() {
  var isOpen = false;
  $(".trigger").on('click', function () {
    if (isOpen == false) {
      $('.nav-main').addClass('open');
      $('.back-menu').addClass('open-back');

      $('body').addClass('blok');
      TweenLite.to(".trigger span:nth-child(3)", 0.4, {
        ease: Power3.easeInOut,
        rotation: 45
      });
      TweenLite.to(".trigger span:nth-child(2)", 0.4, {
        ease: Power3.easeInOut,
        rotation: -45
      });
      TweenLite.to(".trigger span:nth-child(1)", 0.4, {
        ease: Power3.easeInOut,
        left: 100,
        opacity: 0,
        display: 'none'
      });
      TweenLite.to(".trigger span:nth-child(4)", 0.4, {
        ease: Power3.easeInOut,
        left: -100,
        opacity: 0,
        display: 'none'
      });

      isOpen = true;
    } else {
      TweenLite.to(".trigger span:nth-child(3)", 0.4, {
        ease: Power3.easeInOut,
        rotation: 0
      });
      TweenLite.to(".trigger span:nth-child(2)", 0.4, {
        ease: Power3.easeInOut,
        rotation: 0
      });
      TweenLite.to(".trigger span:nth-child(1)", 0.4, {
        ease: Power3.easeInOut,
        left: 22,
        opacity: 1,
        display: 'block'
      });
      TweenLite.to(".trigger span:nth-child(4)", 0.4, {
        ease: Power3.easeInOut,
        left: 24,
        opacity: 1,
        display: 'block'
      });
      $('.nav-main').removeClass('open');
      $('body').removeClass('blok');
      $('.back-menu').removeClass('open-back');
      isOpen = false;
    }
  });
}